import { listItemMsg } from '@/shared/components/FormattedListValue';
import enumCache from '@/shared/services/EnumCacheService';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { defineMessages, injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';

const messages = defineMessages({
  SelectAValue: 'Select a value',
  NoValue: 'No value',
});

class EnumSelect extends Component {
  static defaultProps = {
    value: null,
    orderByLabel: false,
    allowNull: false,
    placeholder: undefined,
    hideItems: [],
  };

  static propTypes = {
    intl: intlShape.isRequired,
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    enumType: PropTypes.string.isRequired,
    orderByLabel: PropTypes.bool,
    allowNull: PropTypes.bool,
    placeholder: PropTypes.string,
    hideItems: PropTypes.arrayOf(PropTypes.number),
  };

  state = {
    options: [],
  };

  componentDidMount() {
    const { intl, enumType, orderByLabel, value, hideItems } = this.props;
    enumCache.get(enumType).then(data => {
      let options = data.map(x => ({
        id: x.key,
        label: intl.formatMessage(listItemMsg(enumType, x.key, x.value)),
      }));
      if (hideItems && hideItems.length > 0) {
        options = options.filter(x => !hideItems.includes(x.id));
      }
      if (orderByLabel) {
        options = options.sort(dynamicSort('label'));
      } else {
        options = options.sort(dynamicSort('id'));
      }
      this.setState({
        options,
        selectedValue: value,
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ selectedValue: this.props.value });
    }
  }

  selectedValueChanged(e) {
    const { onChange } = this.props;
    const { options } = this.state;
    if (e.target.value === '') {
      this.setState({ selectedValue: null }, () => onChange(null));
    } else {
      const selectedOption = options.find(x => x.id === parseInt(e.target.value));
      if (!selectedOption) {
        onChange(null);
        this.setState({ selectedValue: null });
      } else {
        onChange(selectedOption.id);
        this.setState({ selectedValue: selectedOption.id });
      }
    }
  }

  render() {
    const { options, selectedValue } = this.state;
    const { intl, placeholder, allowNull, value } = this.props;

    const hasItemSelected = !!value || value === 0;
    const showPlaceholder = allowNull || !hasItemSelected;

    return (
      <select
        onChange={e => this.selectedValueChanged(e)}
        className="form-control"
        value={selectedValue}
      >
        {showPlaceholder && (
          <option value="">{placeholder || intl.formatMessage(messages.SelectAValue)}</option>
        )}
        {options &&
          options.map(option => (
            <option key={option.id} value={option.id}>
              {option.label}
            </option>
          ))}
      </select>
    );
  }
}

export default injectIntl(EnumSelect);
